/* 
 * Export component file to be used on project
*/

import ModalAdminSchedule from './ModalAdminSchedule';
export default ModalAdminSchedule;
